<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :span='6'>
            <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.dataDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :span="6" :md='8' :sm='6'>
            <a-form-item :label="'产品类型'">
              <a-select
                v-model='queryParam.appSsids'
                mode='multiple'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload'
                        style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>

    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { listTotalAmtByMobile } from '@/webpublicapi/statistics'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'
import moment from 'moment/moment'

const I18N_KEY = 'order.'
export default {
  name: 'reborrowCountByMobile',
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        dataDt: [moment().subtract(1,'M'),moment()],
        appSsids: '',
      },

      loading: false,
      // 表头
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '额度范围',
          align: 'left',
          dataIndex: 'amtRange',
          customRender:(text)=>{
            return this.textToFixed(text,0);
          }
        },
        {
          title: '订单总数',
          align: 'left',
          dataIndex: 'totalNum',
        },
        {
          title: '手机号数',
          align: 'left',
          dataIndex: 'mobileNum'
        },

        {
          title: '订单数（号平均）',
          align: 'left',
          dataIndex: 'totalNumAvg',
          customRender:(text)=>{
            return this.textToFixed(text);
          }
        },
        {
          title: '总额度（号平均）',
          align: 'left',
          dataIndex: 'totalAmtAvg',
          customRender:(text)=>{
            return this.fmtNumberComma33(text);
          }
        },
        {
          title: '未还率（单数）',
          align: 'left',
          dataIndex: 'noSettleNumRate',
          customRender:(text)=>{
            return this.textToFixed(text) + '%';
          }
        },
        {
          title: '逾期率（单数）',
          align: 'left',
          dataIndex: 'overDueNumRate',
          customRender:(text)=>{
            return this.textToFixed(text) + '%';
          }
        },
        {
          title: '每单额度(平均)',
          align: 'left',
          dataIndex: 'orderAmtAvg',
          customRender:(text)=>{
            return this.fmtNumberComma33(text);
          }
        },
        {
          title: '未还订单额度(平均)',
          align: 'left',
          dataIndex: 'noSettleAmtAvg',
          customRender:(text)=>{
            return this.fmtNumberComma33(text)
          }
        },
        {
          title: '逾期订单额度(平均)',
          align: 'left',
          dataIndex: 'overDueAmtAvg',
          customRender: (text) => {
            return this.fmtNumberComma33(text)
          }
        },
        {
          title: '未还率（额度）',
          align: 'left',
          dataIndex: 'noSettleAmtRate',
          customRender:(text)=>{
            return this.textToFixed(text) + '%';
          }
        },
        {
          title: '逾期率（额度）',
          align: 'left',
          dataIndex: 'overDueAmtRate',
          customRender:(text)=>{
            return this.textToFixed(text) + '%';
          }
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: '300px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created() {
    getApplistExcludingSubApp().then(res => {
      this.appList = res.data || []
    })
    // this.loadData(1)
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      const params = this.getQueryParams()// 查询条件
      listTotalAmtByMobile(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam

      const data = {
        ...this.queryParam,
        beginDate: (dataDt && dataDt.length) ? this.transformTime(dataDt[0]) : undefined,
        endDate: (dataDt && dataDt.length) ? this.transformTime(dataDt[1]) : undefined
      }
      delete data.dataDt

      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange (pagination, filters, sorter) {
      this.ipagination = pagination
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      const that = this

      that.queryParam.dataDt = [moment().subtract(1,'M'),moment()]
      that.queryParam.appSsids = ''
    },
    changeModal(visible) {
      this.visible = visible
    },
    /**
     * 格子格式化为千分位
     * @param val 当前值字符串
     * @returns 返回处理后的字符串
     * @isFixed 是否固定2位小数，默认固定
     */
    fmtNumberComma33(val, isFixed = true) {
      if (
        (typeof val !== "string" && typeof val !== "number") ||
        val === "" ||
        val === null ||
        val === undefined ||
        val === "-"
      ) {
        return val;
      }
      let v = null;
      if (typeof val == "string") {
        v = Number(val).toFixed(2);
      } else {
        v = val.toFixed(2);
      }

      if (isFixed) {
        v = typeof val == "string" ? Number(val).toFixed(2) : val.toFixed(2);
      } else {
        v = Number(val || 0);
      }
      // 字符串转成数组
      v = v.toString().split(".");
      // \B 匹配非单词边界，两边都是单词字符或者两边都是非单词字符
      v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // 数组转字符串
      v = v.join(".");
      // 返回结果
      return v;
    },
    textToFixed(text,fixed = 2) {
      let v = '';
      if (typeof text == "string") {
        v = Number(text).toFixed(fixed);
      } else {
        v = text.toFixed(fixed);
      }
      return v + ''
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
